import { render } from "./opportunity.vue?vue&type=template&id=35faed8e&scoped=true"
import script from "./opportunity.vue?vue&type=script&lang=js"
export * from "./opportunity.vue?vue&type=script&lang=js"

import "./opportunity.vue?vue&type=style&index=0&id=35faed8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35faed8e"

export default script